// components
import { SplashScreen } from 'src/components/loading-screen';
//
import { AuthContext } from './auth-context';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function AuthConsumer({ children }: Props) {
  const isRootPath = window.location.pathname === '/';

  return (
    <AuthContext.Consumer>
      {(auth) => (auth.loading && !isRootPath ? <SplashScreen /> : children)}
    </AuthContext.Consumer>
  );
}
